<template>
    <BasicForm  :modal="false" :dialogVisible="clickButton" dialogTitle="查看任务详情" :formModel="planDetail" btnName="关闭"
                @update:dialogVisible="updateDialogVisible" :formRules="[]" @submit="handleForm">
      <el-row>
        <el-col :span="24">
          <el-form-item label="活动类型" prop="category" align="left">
            <el-radio-group v-model="planDetail.category" disabled>
              <el-radio :key=1 :value="1" :label=1 style="color: whitesmoke">正常飞活动</el-radio>
              <el-radio :key=2 :value="2" :label=2 style="color: whitesmoke">报备飞活动</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="运营人名称" prop="operatorNum">
            <el-input v-model="planDetail.operatorName" placeholder="请填写运营人名称" popper-class="adminHomeSelect"
                        disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="运营人执照号" prop="operatorLicense">
            <el-input class="formInputClass" placeholder="请填写运营人执照号" maxlength="200"
                      v-model="planDetail.operatorLicense" disabled>
            </el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="驾驶员名称" prop="pilotId">
            <el-input v-model="planDetail.pilot" filterable placeholder="请选驾驶员信息" popper-class="adminHomeSelect"
                        disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶员执照号" prop="pilotLicense">
            <el-input class="formInputClass" placeholder="请填写驾驶员执照号" maxlength="200"
                      v-model="planDetail.pilotLicense" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>

        <el-col :span="12">
          <el-form-item label="飞机序列号" prop="uavSerial">
            <el-input v-model="planDetail.uavSerial" placeholder="请选择飞机" filterable popper-class="adminHomeSelect"
                        disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="飞机型号" prop="uavModel">
            <el-input class="formInputClass" placeholder="请选择飞机型号" maxlength="200" v-model="planDetail.uavModel"
                      disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="起飞点" prop="startPointId">
            <el-input :value="planDetail.startPoint" placeholder="请选择起飞点" popper-class="adminHomeSelect"
                       disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="降落点" prop="endPointId">
            <el-input :value="planDetail.endPoint" placeholder="请选择降落点" popper-class="adminHomeSelect"
                       disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="起飞时间" prop="startTime">
            <el-date-picker
              class="formInputClass"
              v-model="planDetail.startTime"
              type="datetime"
              placeholder="请选择起飞时间"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="降落时间" prop="endTime">
            <el-date-picker
              class="formInputClass"
              placeholder="请选择降落时间"
              v-model="planDetail.endTime"
              type="datetime"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

        <!-- <el-col :span="12">
          <el-form-item label="任务类型" prop="type">
            <el-input class="formInputClass" placeholder="请填写任务类型" maxlength="200" v-model="planDetail.type"
              :disabled="isDetail">
            </el-input>
          </el-form-item>
        </el-col> -->
        <el-col :span="12" v-if="planDetail.routeName">
          <el-form-item label="航线信息" prop="routeId">
            <el-input v-model="planDetail.routeName" placeholder="请选择航线信息" popper-class="adminHomeSelect"
                      disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务类型" prop="type">
            <el-input :value="planDetail.type == 0 ? '观光' : planDetail.type == 1 ? '巡检' : planDetail.type == 2 ?'物流' :  planDetail.type == 3 ?'应急':'物流' " placeholder="请选择任务类型" popper-class="adminHomeSelect"
                       disabled>
            </el-input>
          </el-form-item>
        </el-col>

      <el-row v-if="planDetail.spaceName">
        <el-col :span="12">
          <el-form-item label="空域信息" prop="spaceId" >
            <el-input v-model="planDetail.spaceName" placeholder="请选择空域信息" popper-class="adminHomeSelect"
                       disabled>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="飞行高度" prop="height" >
            <el-input class="formInputClass" type="number" placeholder="请填写飞行高度" maxlength="200"
                      v-model="planDetail.height" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="note">
            <el-input placeholder="备注信息" maxlength="200" type="textarea" v-model="planDetail.note" disabled>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="驳回原因" prop="reason" >
            <el-input placeholder="驳回原因" maxlength="200" type="textarea" v-model="planDetail.refuseReason"
                      :disabled="true">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
    </BasicForm>
  </template>

  <script>
  import BasicForm from "./BasicForm.vue";

  export default {
    name: "PlanDetail",
    components: {BasicForm},
    props:{
      clickButton: {
        type: Boolean,
        default: false
      },
      taskForm:{
        type:Object,
        default: {
          id: "",
          category: 1,
          planSerial: "",
          uavSerial: "",
          uavModel: "",
          pilotLicense: "",
          pilot: "",
          pilotId: "",
          operatorName: "",
          operatorNum: "",
          operatorLicense: "",
          startPointId: "",
          startPoint: {},
          endPointId: "",
          endPoint: {},
          startTime: "",
          endTime: "",
          routeId: "",
          spaceId: "",
          height: "",
          type: "",
          note: "",
        },
      },
    },
    data() {
      return {
        planDetail:{},
        landPoints: [], //起降点
        airlines: [], //航线信息
        flyers: [], //飞手信息
        opers: [], //运营人信息
        spaces: [], //空域信息
        aircrafts: [], //飞机信息
        typeList:[],//任务类型
      }
    },
    mounted() {
      this.planDetail = {...this.taskForm}
    },
    computed:{
      type(){

      }
    },
    watch:{
      taskForm(newVal, oldVal) {
      this.planDetail = {...newVal}
    },
    },
    methods:{
        updateDialogVisible(newVal){
          this.$emit('update:dialogVisible', newVal);
        },
        handleForm(){
        this.$emit('closeForm', false);
      }
    }
  }
  </script>
  <style scoped>

  </style>



// WEBPACK FOOTER //
// src/common/PlanDetail.vue